import {ReactElement} from 'react';
import Logo from '../logo/logo';
import {Link} from 'react-router-dom';
import {AppRoute} from '../../../const/common';
import {changeCurrentType} from '../../../store/actions';
import {GoodType, GoodTypeName} from '../../../types/goods';
import {useAppDispatch} from '../../../hooks';
import {ScrollPosition, scrollTop} from '../../../utils/common';
import { ReactComponent as IconEmail } from '../../../sprite/icon-email.svg';
import { ReactComponent as IconTelegram } from '../../../sprite/icon-tg.svg';
import { ReactComponent as IconWhatsapp } from '../../../sprite/icon-whatsapp.svg';
import {ExternalLinks} from '../../../const/seo';

export default function Footer(): ReactElement {
  const dispatch = useAppDispatch();

  return (
    <footer className="main-footer">
      <div className="main-footer__inner container text_size--14">
        <div className="main-footer__about">
          <Logo isLight={true}/>
          <p className="text_view--tertiary text_size--12">
            Реализуем крутые ТЗ для вашего IT проекта.
            <br/>
            Индивидуальные техзадания и на заказ.
          </p>
        </div>
        <div className="main-footer__cell main-footer__catalog">
          <h3 className="main-footer__title text_weight--700">Каталог</h3>

          <div className="main-footer__catalog-inner grid grid_col--3">
            <ul className="main-footer__list">
              <li>
                <Link className="link link_view--primary text_weight--700" to={'/katalog/tz-na-razrabotku-igr/tz-dlya-brauzernyh-igr'}>
                  ТЗ на разработку игр
                </Link>
              </li>
              <li>
                <Link className="link link_view--primary" to={'/katalog/tz-na-razrabotku-igr'}>
                  ТЗ для браузерных игр
                </Link>
              </li>
              <li>
                <Link className="link link_view--primary" to={'/katalog/tz-na-razrabotku-igr/tz-dlya-kompyuternyh-igr'}>
                  ТЗ для компьютерных игр
                </Link>
              </li>
              <li>
                <Link className="link link_view--primary" to={'/katalog/tz-na-razrabotku-igr/tz-dlya-mobilnyh-igr'}>
                  ТЗ для мобильных игр
                </Link>
              </li>
            </ul>
            <ul className="main-footer__list">
              <li>
                <Link className="link link_view--primary text_weight--700" to={'/katalog/tz-na-razrabotku-mobilnogo-prilozheniya'}>
                  ТЗ на разработку мобильных приложений
                </Link>
              </li>
              <li>
                <Link className="link link_view--primary" to={'/katalog/tz-na-razrabotku-mobilnogo-prilozheniya/tz-dlya-android'}>
                  ТЗ для Android
                </Link>
              </li>
            </ul>
            <ul className="main-footer__list">
              <li>
                <Link className="link link_view--primary text_weight--700" to={'/katalog/tz-na-razrabotku-sajta'}>
                  ТЗ на разработку сайта
                </Link>
              </li>
              <li>
                <Link className="link link_view--primary" to={'/katalog/tz-na-razrabotku-sajta/tz-na-sajt-vizitku'}>
                  ТЗ для сайта-визитки
                </Link>
              </li>
              <li>
                <Link className="link link_view--primary" to={'/katalog/tz-na-razrabotku-sajta/tz-dlya-portala'}>
                  ТЗ для портала
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="main-footer__cell">
          <h3 className="main-footer__title text_weight--700">О нас</h3>

          <ul className="main-footer__list main-footer__list-about">
            <li>
              <Link
                className="link link_view--primary link_view--hover-opacity"
                to={AppRoute.Blog}
              >
                Блог
              </Link>
            </li>
            <li>
              <Link
                className="link link_view--primary link_view--hover-opacity"
                to={AppRoute.Blog}
              >
                Оплата и доставка
              </Link>
            </li>
            <li>
              <Link
                className="link link_view--primary link_view--hover-opacity"
                to={AppRoute.Blog}
              >
                Контакты
              </Link>
            </li>
          </ul>

          <h3 className="main-footer__title text_weight--700">Контакты</h3>
          <ul className="main-footer__list">
            <li>
              <a
                className="link link_view--primary link_view--hover-underline"
                href={ExternalLinks.InfoEmail}
              >
                <IconEmail className="icon" width={20} height={20}/>
                info@it-tz.ru
              </a>
            </li>
            <li className="main-footer__networks">
              <a className="link link_view--primary" href={ExternalLinks.Telegram}>
                <IconTelegram className="icon" width={32} height={32}/>
                <span className="visuallyhidden">Телеграм</span>
              </a>
              <a className="link link_view--primary" href={ExternalLinks.WhatsApp}>
                <IconWhatsapp className="icon" width={32} height={32}/>
                <span className="visuallyhidden">WhatsApp</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="main-footer__copy text_view--tertiary text_size--14">
        <div className="main-footer__copy-inner container">
          <p>
            Task Store ©{new Date(Date.now()).getFullYear()}{' '}<span>Все права защищены</span>
          </p>
          <p>
            <Link
              className="link link_view--underline"
              to={AppRoute.Privacy}
            >
              Политика конфиденциальности
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
